export class AppIconButton extends HTMLElement {
  static get observedAttributes() {
    return ["aria-label", "disabled", "title"];
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback() {
    this.render();
  }

  private render() {
    const label = this.getAttribute("aria-label") || this.getAttribute("title") || "Ação";
    const disabled = this.hasAttribute("disabled");
    const content = this.innerHTML;

    const existingButton = this.querySelector("button");
    if (existingButton) {
      existingButton.setAttribute("aria-label", label);
      existingButton.disabled = disabled;
      return;
    }

    this.innerHTML = `
      <button type="button" class="btn-icon" aria-label="${label}" title="${label}" ${disabled ? "disabled" : ""}>
        ${content}
      </button>
    `;
  }
}

if (!customElements.get("app-icon-button")) {
  if (!customElements.get("app-icon-button")) {
    customElements.define("app-icon-button", AppIconButton);
  }
}
